import { PACKAGE_TYPE } from '../constants/quote.constants';

const getPackageType = (packageType) => {
  return PACKAGE_TYPE.find((p) => p.value === packageType)?.label;
};

const getDetails = {};

export { getPackageType, getDetails };
